import { createContext, useContext, useState, useEffect } from 'react'
import { authAPI } from '../services/api'

const AuthContext = createContext(null)

export const AuthProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(() => {
    try { return JSON.parse(localStorage.getItem('pos_usuario')) } catch { return null }
  })
  const [cargando, setCargando] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem('pos_token')
    if (!token) { setCargando(false); return }
    authAPI.me()
      .then(r => setUsuario(r.data))
      .catch(() => { localStorage.removeItem('pos_token'); localStorage.removeItem('pos_usuario') })
      .finally(() => setCargando(false))
  }, [])

  const login = async (email, password) => {
    const { data } = await authAPI.login({ email, password })
    localStorage.setItem('pos_token', data.token)
    localStorage.setItem('pos_usuario', JSON.stringify(data.usuario))
    setUsuario(data.usuario)
    return data
  }

  const logout = () => {
    localStorage.removeItem('pos_token')
    localStorage.removeItem('pos_usuario')
    setUsuario(null)
  }

  return (
    <AuthContext.Provider value={{ usuario, login, logout, cargando }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)
